import { createContext } from 'react'

const ConfirmationContext = createContext()

export default ConfirmationContext
